import { EXTENSION_DOM_MARKERS, SUSPICIOUS_PLUGIN_NAMES } from '../constants';
import { CheckResult } from '../types';

function checkPlugins(): string[] {
  const found: string[] = [];

  if (!navigator.plugins) return found;

  Array.from(navigator.plugins).forEach(plugin => {
    const name = plugin.name.toLowerCase();
    const description = plugin.description?.toLowerCase() ?? '';

    if (
      SUSPICIOUS_PLUGIN_NAMES.some(
        s => name.includes(s) || description.includes(s),
      )
    ) {
      found.push(plugin.name);
    }
  });

  return found;
}

function checkDomInjection(): string[] {
  const found: string[] = [];

  EXTENSION_DOM_MARKERS.forEach(selector => {
    try {
      if (document.querySelector(selector)) {
        found.push(selector);
      }
    } catch {
      // Empty catch block
    }
  });

  const suspiciousAttributes = [
    'data-new-gr-c-s-check-loaded',
    'data-gr-ext-installed',
    'spellcheck',
  ];

  const htmlEl = document.documentElement;
  suspiciousAttributes.forEach(attr => {
    if (htmlEl.hasAttribute(attr)) {
      found.push(`[html:${attr}]`);
    }
  });

  return found;
}

export async function extensionCheck(): Promise<CheckResult> {
  const timestamp = new Date().toISOString();

  try {
    const pluginResults = checkPlugins();
    const domResults = checkDomInjection();

    const suspiciousFindings = [...pluginResults, ...domResults];

    if (suspiciousFindings.length > 0) {
      return {
        checkId: 'suspicious_extensions',
        checkName: 'Extensões Suspeitas',
        status: 'warning',
        details: `Extensão suspeita detectada: ${suspiciousFindings.join(
          ', ',
        )}. Desative extensões de cola durante a prova.`,
        timestamp,
        metadata: {
          suspiciousPlugins: pluginResults,
          suspiciousDomMarkers: domResults,
        },
      };
    }

    return {
      checkId: 'suspicious_extensions',
      checkName: 'Extensões Suspeitas',
      status: 'passed',
      details: 'Nenhuma extensão suspeita detectada.',
      timestamp,
      metadata: {
        pluginsChecked: navigator.plugins?.length ?? 0,
        domMarkersChecked: EXTENSION_DOM_MARKERS.length,
      },
    };
  } catch {
    return {
      checkId: 'suspicious_extensions',
      checkName: 'Extensões Suspeitas',
      status: 'warning',
      details: 'Não foi possível verificar extensões do navegador.',
      timestamp,
    };
  }
}
